import { render, staticRenderFns } from "./update-recruitment-last-date.vue?vue&type=template&id=36664ed9&scoped=true"
import script from "./update-recruitment-last-date.vue?vue&type=script&lang=js"
export * from "./update-recruitment-last-date.vue?vue&type=script&lang=js"
import style0 from "./update-recruitment-last-date.vue?vue&type=style&index=0&id=36664ed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36664ed9",
  null
  
)

export default component.exports